import { createMachine } from 'xstate';
import { Events } from './types';

export const threeDs = createMachine<null, Events>({
  predictableActionArguments: true,
  id: 'threeDs',
  initial: 'idle',
  states: {
    idle: {
      on: {
        THREE_DS_SUCCESS: 'loading',
      },
    },
    loading: {
      invoke: {
        src: 'getSubscriptionDetails',
        onError: {
          target: 'error',
        },
        onDone: {
          target: 'success',
          actions: 'updateSubscriptions',
        },
      },
    },
    success: {
      type: 'final',
    },
    error: {
      type: 'final',
    },
  },
});
